import * as siteActions from '@lib/actions/SiteAction';
import { addTranslateToProps, ITranslationProps } from '@lib/i18n/translation';
import Schedule from '@lib/pages/Schedule';
import { ISchedule, ISite, IStoreSiteState, ITempChannel } from '@lib/types/index';
import { connect, Dispatch } from 'react-redux';


export function mapStateToProps(state: any): IScheduleProps {
  const siteState: IStoreSiteState = state.site;
  return addTranslateToProps({
    errorMessage: siteState.errorMessage,
    saving: siteState.saving,
    site: siteState.site ? JSON.parse(JSON.stringify(siteState.site)) : {},
    successMessage: siteState.successMessage,
    temp: siteState.temp,
    working: siteState.working,
  })
}

export function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onGoBack: () => dispatch(siteActions.navigateToDashboard()),
    onSave: (idDevice: string, name: string, schedules: ISchedule[]) => dispatch(siteActions.asyncScheduleSaveAction(idDevice, name, schedules)),
  }
}

interface IScheduleProps extends ITranslationProps {
  errorMessage: string;
  saving: boolean;
  site: ISite;
  successMessage: string;
  temp: ITempChannel;
  working: boolean;
}

interface IScheduleDispatchProps {
  onSave(idDevice: string, name: string, schedules: ISchedule[]): void;
  onGoBack(): void;
}

export type ScheduleProps = IScheduleProps & IScheduleDispatchProps;

export default connect<IScheduleProps, IScheduleDispatchProps, any>(mapStateToProps, mapDispatchToProps)(Schedule);


// WEBPACK FOOTER //
// ./src/containers/Schedule.tsx